import { render } from "./prefixes-settings.vue?vue&type=template&id=014ccb54"
import script from "./prefixes-settings.vue?vue&type=script&lang=js"
export * from "./prefixes-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__